// Load External Libraries
import AOS from 'aos'
//import 'owl.carousel';
import {jarallax, jarallaxVideo} from 'jarallax';
import {Fancybox} from "@fancyapps/ui";

// other packages here...

window.$ = window.jQuery = jQuery;

//Load Bootstrap Libraries
//import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
//import 'bootstrap/js/dist/collapse';
//import 'bootstrap/js/dist/dropdown'; //also requires Popper
//import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/offcanvas';
//import 'bootstrap/js/dist/popover'; //also requires Popper
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import Tooltip from 'bootstrap/js/dist/tooltip'; //also requires Popper

//Local imports
import { serviceWorker } from './modules/_serviceWorker.mjs';
import { validate } from './modules/_validate.mjs';
import { navigation } from "./modules/_navigation.mjs";
import { sponsorSlider } from "./modules/_carousels.mjs";
import { Disclosure } from "./modules/_disclosure.mjs";
import { Accordion } from "./modules/_accordion.mjs";
import { verslagenSlider } from "./modules/_carousels.mjs";

//initialize functions
document.addEventListener("DOMContentLoaded", function() {
    serviceWorker();
    validate();
    navigation();
    //exampleSlider()
    AOS.init({startEvent: 'load', disable: 'mobile'});
    jarallax(document.querySelectorAll('.jarallax'), { speed: 0.8 });
    //jarallaxVideo();
    sponsorSlider();
    verslagenSlider();

    const disclosure = new Disclosure();
    const accordion = new Accordion();
});



let baseOpacity = 0.85;
let overlay = document.querySelector('.bg-overlay');
window.addEventListener('scroll', function() {

    if (scrollY < 1200) {
        overlay.style.opacity = (baseOpacity + (0.00015 * scrollY)).toString();
    } else {
        overlay.style.opacity = '1';
    }

});





let height;
function expandHeight(element) {

    element.classList.add('active', 'transitioning'); // Set active state styles (setting display to block, visibility to visible, etc.) as well as transitioning styles, so it can actually transition from height: 0; to height: auto;

    element.style.height = 'auto'; // Set the element's height to auto after it becomes visible, so we can obtain the element's computed height
    height = element.scrollHeight + 'px'; // set the variable 'height' to be equal to the element's computed height (scrollbar included)

    element.style.height = '0px'; // Set the element's height back to 0 after we obtain the rendered height so the element can transition from it. This happens before the browser is able to repaint the element, so height: auto; is never actually displayed on screen.

    // Use requestAnimationFrame for smoother animation on repaint from display: none, visibility: hidden, etc.
    requestAnimationFrame(function () {
        // Allow time for the rendering before transitioning
        setTimeout(function () {
            element.style.height = height; // Set the element's height to be equal to the 'height' variable declared above
        });
    });

    // When transition ends, remove the 'transitioning' class. This class is typically used to disable click Events while the element is still in the middle of transitioning.
    element.addEventListener('transitionend', function() {
        element.classList.remove('transitioning');
        element.style.height = ''; // When the transition has finished, the element's height (contained in the 'height' variable) should be equal to the value of 'auto', so we can remove it. This ensures the height of the element can be recalculated when the viewport changes.
    });

}

//animate element from height: auto; to height: 0;
//IMPORTANT: animating an element's dimensions causes layout trashing and forces the browser to repaint on every frame of the transition, which is not performant. It can also cause issues when the viewport changes in the middle of a transition. Don't use it if you don't have to.
// ===============================================
function collapseHeight(element) {

    height = element.scrollHeight + 'px'; // set the value of the variable 'height' to be equal to the element's computed height (scrollbar included), so we can use that to transition from
    element.style.height = height; // set the element's height to be equal to the 'height' variable. The height variable contains a fixed value that should be equal to 'auto'. We do this, because it's not possible to transition from height: auto;

    // Use requestAnimationFrame for smoother animation on repaint from display: none, visibility: hidden, etc.
    requestAnimationFrame(function () {
        // Allow time for the rendering before transitioning
        setTimeout(function () {
            element.style.height = '0px'; // Set the element's height to 0
            element.classList.add('transitioning'); // add the transitioning styles back, so it can actually transition from the computed height to 0. (todo: should this be at the very top?)
        });
    });

    // When transition ends, remove the 'transitioning' class. This class is typically used to disable click Events while the element is still in the middle of transitioning. We also remove the 'active' class so the element can be disabled (e.g. by setting display to none, visibility to hidden, etc.)
    element.addEventListener('transitionend', function() {
        element.classList.remove('active', 'transitioning');
    }, {
        once: true // Remove the eventListener from the element when it is no longer visible, so it doesn't try to remove these classes again when the element's height is expanded a 2nd time.
    });

}

const nav = document.querySelector('.primary-navigation');
const headerMain = document.querySelector('.header-main');
nav.addEventListener('mouseover', function() {
    if (nav.matches(':hover') || nav.querySelector('*:focus')) {
        nav.classList.add('active');
        console.log('true');
    } else {
        console.log('false');
    }
})
headerMain.addEventListener('mouseleave', function() {
    nav.classList.remove('active');
});




let rowbtns = document.querySelectorAll('.btn-togglerows');

if (rowbtns) {

    let toggleAll = document.querySelector('.btn-toggleall');
    rowbtns.forEach(function (rowbtn) {
        rowbtn.addEventListener('click', function() {
            const rows = rowbtn.closest('tr').querySelectorAll('ul');
            if (rowbtn.getAttribute('aria-expanded') === 'true') {
                rowbtn.setAttribute('aria-expanded', 'false');
                rows.forEach(function(row) {
                    //row.classList.add('hidden');
                    collapseHeight(row);
                });
            } else {
                rowbtn.setAttribute('aria-expanded', 'true');
                rows.forEach(function(row) {
                    // row.classList.remove('hidden');
                    expandHeight(row);
                });
            }
        });
    });

    if (toggleAll) {
        toggleAll.addEventListener('click', function() {
            const table = this.closest('table');
            const buttons = table.querySelectorAll('.btn-togglerows');
            const rows = table.querySelectorAll('tr ul');

            if (this.getAttribute('aria-expanded') === 'true') {
                this.setAttribute('aria-expanded', 'false');
                buttons.forEach(function(button) {
                    button.setAttribute('aria-expanded', 'false');
                });
                rows.forEach(function(row) {
                    collapseHeight(row);
                });
            } else {
                this.setAttribute('aria-expanded', 'true');
                buttons.forEach(function(button) {
                    button.setAttribute('aria-expanded', 'true');
                });
                rows.forEach(function(row) {
                    expandHeight(row);
                });
            }

        });
    }

}



document.addEventListener('click', function(event) {
    // Assuming 'elementToClose' is the element you want to close
    var navWrapper = document.getElementById('navwrapper-offcanvas');

    // Assuming 'childDiv' is the child div inside the element
    var navElement = document.querySelector('.navigation-menu-wrapper');

    // Check if the clicked element is not the child div
    if (!navElement.contains(event.target) && navWrapper.classList.contains('show')) {
        // Close the element or perform your desired action
        document.getElementById('navwrapper-offcanvas').classList.remove('show');
    }
});


document.getElementById('navtoggler-open').addEventListener('click', function() {
    setTimeout(function() {
        document.getElementById('navwrapper-offcanvas').classList.add('show');
    }, 100)
});
document.getElementById('navtoggler-close').addEventListener('click', function() {
    document.getElementById('navwrapper-offcanvas').classList.remove('show');
});